import React, { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
`;

const StyledInput = styled.input`
  border: none;
  border-bottom: 1px solid #fff;
  font-weight: bold;
  border-radius: 0;
  padding-right: 2.25rem;
  &::placeholder {
    color: #fff;
    opacity: 1;
  }
`;

const ToggleButton = styled.button`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #fff;
  padding: 0;
  line-height: 1;
  cursor: pointer;
`;

export default function PasswordInput({ className, ...rest }) {
  const [visible, setVisible] = useState(false);

  return (
    <Wrapper>
      <StyledInput
        className={className}
        type={visible ? "text" : "password"}
        {...rest}
      />
      <ToggleButton
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
      >
        <i className={visible ? "fas fa-eye-slash" : "fas fa-eye"}></i>
      </ToggleButton>
    </Wrapper>
  );
}
